import { call, put, takeEvery, select } from "redux-saga/effects";
import axios from "axios";
import {
  GET_SIGNATURE,
  GET_SIGNATURE_SUCCESS,
  CREATE_SIGNATURE,
  UPLOAD_SIGNATURE_FILE,
  UPDATE_SIGNATURE,
  REMOVE_SIGNATURE,
  FETCH_SIGNER_DATA,
  FETCH_SIGNER_DATA_SUCCESS,
  FETCH_SIGNER_DATA_FAILURE,
  SUBMIT_CONSENT,
  SUBMIT_CONSENT_SUCCESS,
  SUBMIT_CONSENT_FAILURE,
  CREATE_SIGNATURE_SUCCESS,
  CREATE_SIGNATURE_FAILURE,
  GET_SIGNATURE_FAILURE,
  CLOSE_SIGNATURE_MODAL,
  FETCH_SIGNER_CHART_DATA,
  FETCH_TEMPLATE_DATA,
} from "../actions/actionTypes";
import { apiKey, serverBaseUrl } from "../../config/envs";

const getSignerData = (state) => state.signature.signerData;
const getSignDoc = (state) => state.signature.signedDoc;

const BASE_URL = serverBaseUrl;
// const API_HEADERS = {
//   'sign-secret-id': apiKey,
// };

// Helper function for API calls
const apiCall = (method, endpoint, data = null, options = {}) => {
  return axios({
    method,
    url: `${BASE_URL}${endpoint}`,
    data,
    ...options,
  });
};

// Fetch Signature
function* fetchSignature(action) {
  try {
    const response = yield call(
      apiCall,
      "get",
      `/get_signature?signerId=${action.payload.signerId}`,
      null,
      {
        headers: {
          "sign-secret-id": action.payload.signSecretId,
        }, //API_HEADERS,
      }
    );
    yield put({ type: GET_SIGNATURE_SUCCESS, signedDoc: response.data?.data });
  } catch (error) {
    console.error("Fetch signature error:", error);
    yield put({ type: GET_SIGNATURE_FAILURE, error });
  }
}

// Create Signature
function* createSignature(action) {
  const signerData = yield select(getSignerData);

  const payload = {
    signerId: signerData?.data?.signers[0]?.id,
    clinicId: signerData?.data?.qualiphy_clinic_id,
    url: action.payload?.url,
    path: "1734986670113-download.jpeg",
  };

  try {
    const response = yield call(apiCall, "post", "/create_signature", payload, {
      headers: {
        "sign-secret-id": action.payload.signSecretId,
      },
    });
    if (response.data) {
      // Close the modal after successful signature creation
      yield put({ type: CLOSE_SIGNATURE_MODAL });
    }

    yield put({ type: CREATE_SIGNATURE_SUCCESS, payload: response.data?.data });
    yield put({
      type: GET_SIGNATURE,
      payload: {
        signerId: payload.signerId,
        signSecretId: action.payload.signSecretId,
      },
    });
  } catch (error) {
    console.error("Create signature error:", error);
    yield put({
      type: CREATE_SIGNATURE_FAILURE,
      payload: error.response?.data || error.message,
    });
  }
}

// Update Signature
function* updateSignature(action) {
  const signerData = yield select(getSignerData);

  const payload = {
    signerId: signerData?.data?.signers[0]?.id,
    clinicId: signerData?.data?.qualiphy_clinic_id,
    url: action.payload?.url,
    path: action.payload?.path || "1734986670113-download.jpeg",
  };

  try {
    const response = yield call(apiCall, "put", "/update_signature", payload, {
      headers: {
        "sign-secret-id": action.payload.signSecretId,
      },
    });
    // yield put({ type: GET_SIGNATURE_SUCCESS, signedDoc: response.data?.data });
    if (response.data) {
      // Close the modal after successful signature creation
      yield put({ type: CLOSE_SIGNATURE_MODAL });
    }

    yield put({ type: CREATE_SIGNATURE_SUCCESS, payload: response.data?.data });
    yield put({
      type: GET_SIGNATURE,
      payload: {
        signerId: payload.signerId,
        signSecretId: action.payload.signSecretId,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Update signature error:", error);
    throw error;
  }
}

// Upload Signature
function* uploadSignature(action) {
  try {
    const formData = new FormData();
    formData.append("file", action.payload.file);

    const uploadResponse = yield call(apiCall, "post", "/upload", formData, {
      headers: {
        "sign-secret-id": action.payload.signSecretId,
      },
    });
    const seignDoc = yield select(getSignDoc);
    const uploadedFileUrl = uploadResponse.data?.data?.url;
    if (uploadedFileUrl) {
      if (action.payload.existingSignatureUrl) {
        yield put({
          type: UPDATE_SIGNATURE,
          payload: {
            ...action.payload,
            url: uploadedFileUrl,
            path: seignDoc[0]?.path,
            isUpdate: !!action.existingSignatureUrl,
            signSecretId: action.payload.signSecretId,
          },
        });
      } else {
        yield put({
          type: CREATE_SIGNATURE,
          payload: {
            ...action.payload,
            url: uploadedFileUrl,
            isUpdate: !!action.existingSignatureUrl,
            signSecretId: action.payload.signSecretId,
          },
        });
      }
    }
  } catch (error) {
    console.error("Upload signature error:", error);
  }
}

// Remove Signature
function* removeSignature(action) {
  try {
    const res = yield call(
      apiCall,
      "delete",
      "/remove_signature",
      action.payload,
      {
        headers: {
          "sign-secret-id": action.payload.signSecretId,
        },
      }
    );
    yield put({
      type: GET_SIGNATURE,
      payload: {
        signerId: action.payload.signerId,
        signSecretId: action.payload.signSecretId,
      },
    });
  } catch (error) {
    console.error("Remove signature error:", error);
  }
}

// Fetch Signer Data
function* fetchSignerData(action) {
  try {
    const response = yield call(
      apiCall,
      "get",
      `/get_details_sign_link?sign_secret_id=${action.payload.signSecretId}`,
      null,
      {
        headers: {
          "sign-secret-id": action.payload.signSecretId,
        },
      }
    );
    yield put({ type: FETCH_SIGNER_DATA_SUCCESS, payload: response.data });
  } catch (error) {
    console.error("Fetch signer data error:", error);
    yield put({
      type: FETCH_SIGNER_DATA_FAILURE,
      payload: error.response?.data || error.message,
    });
  }
}

// Fetch Template Data
function* fetchTemplateData(action) {
  try {
    const response = yield call(
      apiCall,
      "get",
      `/get_template_sign_details?sign_secret_id=${action.payload}`,
      null,
      {
        headers: {
          "sign-secret-id": action.payload,
        },
      }
    );
    yield put({ type: FETCH_SIGNER_DATA_SUCCESS, payload: response.data });
  } catch (error) {
    console.error("Fetch signer data error:", error);
    yield put({
      type: FETCH_SIGNER_DATA_FAILURE,
      payload: error.response?.data || error.message,
    });
  }
}

// Fetch Signer Data
function* fetchSignerChartData(action) {
  try {
    const response = yield call(
      apiCall,
      "get",
      `/get_collab_charts?page=${action.payload.page}&limit=${action.payload.limit}&chart_id=${action.payload.chartId}`,
      null,
      {
        headers: {
          // The /collab-charts/<secret> review link carries the sign_secret_id in
          // the URL; the saga forwards it (payload.collabSecret) as the credential.
          "sign-secret-id": action.payload.collabSecret,
        },
      }
    );
    yield put({ type: FETCH_SIGNER_DATA_SUCCESS, payload: response.data });
  } catch (error) {
    console.error("Fetch signer data error:", error);
    yield put({
      type: FETCH_SIGNER_DATA_FAILURE,
      payload: error.response?.data || error.message,
    });
  }
}

// Submit Consent API
const submitConsentAPI = async (data, signSecretId) => {
  return apiCall(
    "post",
    "/sign_consent",
    {
      qualiphy_clinic_id: data?.data?.qualiphy_clinic_id,
      sign_link_id: data.data?.signers[0]?.sign_link_id,
      qualiphy_admin_id: data?.data?.qualiphy_admin_id,
      qualiphy_user_id: 13,
      signer_id: data.data?.signers[0]?.id,
    },
    {
      headers: { "sign-secret-id": signSecretId },
    }
  );
};

// Submit Consent
function* submitConsent(action) {
  const { data, signSecretId } = action.payload;
  try {
    const response = yield call(submitConsentAPI, data, apiKey);
    if (response?.data) {
      yield put({ type: SUBMIT_CONSENT_SUCCESS, payload: response.data });
      yield put({
        type: FETCH_SIGNER_DATA,
        payload: { signSecretId },
      });
    }
  } catch (error) {
    console.error("Submit consent error:", error);
    yield put({
      type: SUBMIT_CONSENT_FAILURE,
      payload: error.response?.data || error.message,
    });
  }
}

export default function* signatureSaga() {
  yield takeEvery(GET_SIGNATURE, fetchSignature);
  yield takeEvery(CREATE_SIGNATURE, createSignature);
  yield takeEvery(UPLOAD_SIGNATURE_FILE, uploadSignature);
  yield takeEvery(UPDATE_SIGNATURE, updateSignature);
  yield takeEvery(REMOVE_SIGNATURE, removeSignature);
  yield takeEvery(FETCH_SIGNER_DATA, fetchSignerData);
  yield takeEvery(FETCH_SIGNER_CHART_DATA, fetchSignerChartData);
  yield takeEvery(FETCH_TEMPLATE_DATA, fetchTemplateData);
  yield takeEvery(SUBMIT_CONSENT, submitConsent);
}
